import dayjs from 'dayjs';

type DateInput = Date | string | null | undefined;

const FALLBACK = '-';

function parse(value: DateInput): dayjs.Dayjs | null {
  if (value === null || value === undefined || value === '') return null;
  const d = dayjs(value);
  return d.isValid() ? d : null;
}

export function formatDate(value: DateInput): string {
  return parse(value)?.format('DD MMM YYYY') ?? FALLBACK;
}

export function formatDateShort(value: DateInput): string {
  return parse(value)?.format('DD MMM YY') ?? FALLBACK;
}

export function formatDateNumeric(value: DateInput): string {
  return parse(value)?.format('DD/MM/YYYY') ?? FALLBACK;
}

export function formatDateTime(value: DateInput): string {
  return parse(value)?.format('DD MMM YYYY, HH:mm') ?? FALLBACK;
}

export function formatDateTimeWithSeconds(value: DateInput): string {
  return parse(value)?.format('DD MMM YYYY, HH:mm:ss') ?? FALLBACK;
}
